module.exports = __webpack_public_path__ + "static/media/chart_icon.129763c8.svg";